var _defs, _rect, _rect2, _g, _g2, _g3, _g4, _g5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    zoomAndPan: "magnify",
    viewBox: "0 0 90 60",
    height: 80,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a849185b08"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69 11 L 72.382812 11 L 72.382812 15 L 69 15 Z M 69 11 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9cf2d65336"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44 9.132812 L 72.382812 9.132812 L 72.382812 25 L 44 25 Z M 44 9.132812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1542d92d17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.632812 9.132812 L 52 9.132812 L 52 26 L 17.632812 26 Z M 17.632812 9.132812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 2643557117
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63 26 L 72.382812 26 L 72.382812 51 L 63 51 Z M 63 26 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "82026a4648"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.632812 22 L 44 22 L 44 51 L 17.632812 51 Z M 17.632812 22 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -9,
    width: 108,
    fill: "#ffffff",
    y: -6,
    height: 72,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -9,
    width: 108,
    fill: "#ffffff",
    y: -6,
    height: 72,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a849185b08)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e94e24",
    d: "M 70.800781 11.417969 C 71.054688 11.417969 71.304688 11.484375 71.546875 11.621094 C 71.789062 11.757812 71.980469 11.949219 72.117188 12.203125 C 72.253906 12.453125 72.320312 12.71875 72.320312 12.992188 C 72.320312 13.265625 72.253906 13.523438 72.117188 13.773438 C 71.984375 14.027344 71.796875 14.21875 71.554688 14.359375 C 71.316406 14.496094 71.0625 14.5625 70.800781 14.5625 C 70.535156 14.5625 70.285156 14.496094 70.042969 14.359375 C 69.800781 14.21875 69.613281 14.023438 69.476562 13.773438 C 69.34375 13.523438 69.277344 13.265625 69.277344 12.992188 C 69.277344 12.722656 69.34375 12.453125 69.480469 12.203125 C 69.617188 11.949219 69.808594 11.757812 70.050781 11.621094 C 70.292969 11.484375 70.542969 11.417969 70.800781 11.417969 Z M 70.800781 11.679688 C 70.585938 11.679688 70.378906 11.734375 70.175781 11.847656 C 69.972656 11.960938 69.816406 12.125 69.703125 12.335938 C 69.585938 12.546875 69.527344 12.765625 69.527344 12.992188 C 69.527344 13.222656 69.585938 13.4375 69.699219 13.644531 C 69.808594 13.855469 69.96875 14.015625 70.167969 14.132812 C 70.371094 14.246094 70.582031 14.304688 70.800781 14.304688 C 71.019531 14.304688 71.230469 14.246094 71.433594 14.132812 C 71.632812 14.015625 71.789062 13.855469 71.902344 13.644531 C 72.011719 13.4375 72.070312 13.222656 72.070312 12.992188 C 72.070312 12.765625 72.011719 12.546875 71.898438 12.335938 C 71.785156 12.125 71.628906 11.960938 71.425781 11.847656 C 71.222656 11.734375 71.015625 11.679688 70.800781 11.679688 M 70.132812 13.863281 L 70.132812 12.171875 L 70.695312 12.171875 C 70.890625 12.171875 71.027344 12.183594 71.113281 12.214844 C 71.199219 12.246094 71.265625 12.300781 71.320312 12.378906 C 71.371094 12.457031 71.394531 12.539062 71.394531 12.628906 C 71.394531 12.75 71.351562 12.859375 71.265625 12.953125 C 71.179688 13.042969 71.070312 13.097656 70.925781 13.105469 C 70.984375 13.132812 71.03125 13.160156 71.066406 13.195312 C 71.132812 13.265625 71.214844 13.375 71.308594 13.53125 L 71.507812 13.863281 L 71.1875 13.863281 L 71.042969 13.597656 C 70.925781 13.386719 70.835938 13.257812 70.765625 13.203125 C 70.71875 13.164062 70.648438 13.144531 70.554688 13.144531 L 70.398438 13.144531 L 70.398438 13.863281 Z M 70.398438 12.910156 L 70.71875 12.910156 C 70.871094 12.910156 70.976562 12.886719 71.03125 12.835938 C 71.089844 12.789062 71.117188 12.726562 71.117188 12.648438 C 71.117188 12.601562 71.105469 12.554688 71.078125 12.515625 C 71.050781 12.476562 71.011719 12.445312 70.964844 12.425781 C 70.917969 12.40625 70.828125 12.398438 70.699219 12.398438 L 70.398438 12.398438 Z M 70.398438 12.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9cf2d65336)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e94e24",
    d: "M 72.285156 20.199219 L 63.082031 24.988281 L 44.847656 15.726562 L 51.78125 9.636719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1542d92d17)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e94e24",
    d: "M 51.78125 9.636719 L 44.84375 15.726562 L 17.667969 25.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2643557117)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M 72.3125 31.121094 L 72.3125 26.800781 L 63.140625 31.933594 L 63.140625 43.542969 L 70.40625 39.535156 L 70.40625 42.609375 L 63.140625 46.738281 L 63.140625 50.945312 L 72.3125 45.847656 L 72.3125 34.160156 L 65.046875 38.261719 L 65.046875 35.097656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#82026a4648)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M 17.667969 43.605469 L 41.164062 35.242188 L 41.164062 38.308594 L 17.667969 46.617188 L 17.667969 50.949219 L 43.066406 41.964844 L 43.066406 30.238281 L 20.402344 38.308594 L 20.402344 35.289062 L 43.085938 27.15625 L 43.085938 22.832031 L 17.667969 31.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M 44.976562 22.15625 L 44.976562 33.878906 L 59.328125 41.511719 L 59.328125 44.6875 L 44.976562 36.960938 L 44.976562 41.285156 L 61.230469 49.929688 L 61.230469 38.316406 L 46.898438 30.59375 L 46.898438 27.507812 L 61.230469 35.125 L 61.230469 30.910156 L 44.996094 22.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.ce683561cc44b9d6843188aeeb0177ab.svg";
export { ForwardRef as ReactComponent };